import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// utils
import { getMessage } from 'util/locale';
import { convertDisplayValues, getOverlayLegendTitle } from 'util/legend';
import { min, max, isEmpty } from 'lodash';

// components
import Legend from 'mapping/legends/Legend';
import EditLegendContainer from './EditLegendContainer';

const OverlayLegend = ({
  cropNominalWeight = null,
  isEditable = false,
  isRetractable = false,
  legend,
  toggleEditLegend = null
}) => {
  if (isEmpty(legend)) {
    return null;
  }

  const classString = classNames({
    'vra-overlay-legend__legend': true,
    [`vra-overlay-legend__legend--${legend.layer}`]: !!legend.layer
  });
  
  const convertedDisplayValues = convertDisplayValues({legend, cropNominalWeight});
  const title = getOverlayLegendTitle(legend.labelKey);
  const convertedRawValues = !isEditable || !convertDisplayValues 
    ? [] 
    : convertDisplayValues({legend, cropNominalWeight, localized: false});

  return (
    <div className={`vra-overlay-legend-container`}>
      {isEditable 
        ? <EditLegendContainer
          cropNominalWeight={cropNominalWeight}
          maxValue={Math.round(max(convertedRawValues))}
          minValue={Math.round(min(convertedRawValues))}
          steps={legend.rawValues.length} 
        /> : null }
      <Legend
        className={classString}
        colors={legend.colors}
        displayValues={convertedDisplayValues}
        highLabel={getMessage(`${legend.labelKey}--high`)}
        isEditable={isEditable}
        isRetractable={isRetractable}
        lowLabel={getMessage(`${legend.labelKey}--low`)}
        title={title}
        toggleEditLegend={toggleEditLegend}
      />
    </div>
  );
};
OverlayLegend.propTypes = {
  cropNominalWeight: propTypes.number,
  isEditable: propTypes.bool,
  isRetractable: propTypes.bool,
  legend: propTypes.object.isRequired,
  toggleEditLegend: propTypes.func
};
export default OverlayLegend;
